import { SignInForm } from "../components/Form/SignInForm";
import AuthPageLayout from "../components/AuthPageLayout/AuthPageLayout";

import { LoginGoogleButton } from "../components/LoginGoogleButton";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { useState } from "react";

const SignInPage = () => {
  const [isEmail, setIsEmail] = useState(true);
  return (
    <AuthPageLayout>
      {isEmail ? (
        <Box width={500}>
          <Typography
            fontWeight="700"
            color="black"
            mb={2}
            textAlign={"left"}
            sx={{
              fontSize: "1.6rem",
              lineHeight: "2rem",
              letterSpacing: "-.025em",
            }}
          >
            Te damos la bienvenida a <br /> Plusval Estate
          </Typography>
          <Typography
            fontWeight={"500"}
            color="black"
            mb={2}
            textAlign={"left"}
            sx={{
              fontSize: "1.06rem",
              lineHeight: "1.25rem",
              color: "#596173",
            }}
          >
            Accede a tu cuenta usando tus redes sociales o correo electrónico
          </Typography>

          <Stack spacing={4} mt={4}>
            <LoginGoogleButton />
            <Box position="relative" my={3}>
              <Divider />
              <Typography
                variant="caption"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "white",
                  px: 2,
                  color: "#a95052",
                  textTransform: "uppercase",
                }}
              >
                O continúa con
              </Typography>
            </Box>
            <Button
              onClick={() => {
                setIsEmail(false);
              }}
              variant="contained"
              size="large"
              sx={{
                backgroundColor: "#a95052",
                "&:hover": { backgroundColor: "#8c3e47" },
              }}
            >
              Correo Electronico
            </Button>
          </Stack>
        </Box>
      ) : (
        <SignInForm isBack={() => setIsEmail(true)} />
      )}
    </AuthPageLayout>
  );
};

export default SignInPage;
